import React from "react";
import { cedisLocale } from "../../helpers/utilities";
import {
  Select,
  NumberInput,
  ActionIcon,
  Tooltip,
  Divider,
  Text,
} from "@mantine/core";
import { IconDiscount, IconTrash } from "@tabler/icons";

export default function BillItemsComponent({
  item,
  onUpdate,
  onDelete,
  services = [],
  onDiscountToggle,
  canEditPrice = false,
  disabled = false,
}) {
  const selectedService = services?.find((s) => s?.id === item?.serviceId);
  const baseRate = parseFloat(item?.rate || selectedService?.baseRate || 0);
  const quantity = parseInt(item.quantity || 0);
  const itemDiscount = parseFloat(item.discount || 0);
  const itemDiscountType = item.discountType || "value";

  const subtotal = baseRate * quantity;
  const discountAmount =
    itemDiscountType === "percent"
      ? (subtotal * itemDiscount) / 100
      : itemDiscount;
  const finalAmount = subtotal - discountAmount;

  const handleDiscountChange = (value) => {
    onUpdate({
      recordId: item.recordId,
      field: "discount",
      value: value || 0,
    });
  };

  const handleDiscountTypeChange = () => {
    const newType = itemDiscountType === "value" ? "percent" : "value";
    onUpdate({
      recordId: item.recordId,
      field: "discountType",
      value: newType,
    });
  };

  return (
    <div className="row align-items-center py-2 px-3">
      <div className="col-4">
        <Select
          id="serviceId"
          value={item?.serviceId}
          nothingFound="No match"
          disabled={disabled}
          onChange={(value) => {
            const selectedService = services?.find((s) => s?.id === value);
            onUpdate({ recordId: item.recordId, field: "serviceId", value });
            if (selectedService) {
              onUpdate({
                recordId: item.recordId,
                field: "rate",
                value: selectedService.baseRate,
              });
            }
          }}
          size="sm"
          clearable
          searchable
          placeholder="Select service"
          data={services?.map((serv) => ({
            label: `(${serv.serviceCode}) ${serv.serviceName}`,
            value: serv.id,
          }))}
        />
      </div>
      <div className="col-2 text-center">
        {canEditPrice ? (
          <NumberInput
            value={baseRate}
            onChange={(value) =>
              onUpdate({
                recordId: item.recordId,
                field: "rate",
                value: value != null && value !== "" ? parseFloat(value) : 0,
              })
            }
            min={0}
            size="sm"
            placeholder="0.00"
            disabled={disabled}
          />
        ) : (
          <Text weight={600}>
            {cedisLocale.format(parseFloat(baseRate).toFixed(1))}
          </Text>
        )}
      </div>
      <div className="col-2 text-center">
        <NumberInput
          value={quantity}
          onChange={(value) =>
            onUpdate({
              recordId: item.recordId,
              field: "quantity",
              value: value || 0,
            })
          }
          min={1}
          size="sm"
          placeholder="Qty"
          disabled={disabled}
        />
      </div>
      <div className="col-2">
        <div className="d-flex align-items-center gap-1">
          <NumberInput
            value={itemDiscount}
            onChange={handleDiscountChange}
            min={0}
            max={itemDiscountType === "percent" ? 100 : subtotal}
            size="sm"
            placeholder="0.00"
            disabled={disabled}
          // placeholder={itemDiscountType === "percent" ? "0%" : "0.00"}
          // rightSection={
          //   <Tooltip
          //     label={`Switch to ${
          //       itemDiscountType === "percent" ? "amount" : "percentage"
          //     }`}>
          //     <ActionIcon
          //       size="xs"
          //       variant="subtle"
          //       onClick={handleDiscountTypeChange}>
          //       <IconDiscount size={12} />
          //     </ActionIcon>
          //   </Tooltip>
          // }
          />
          {/* <small className="text-muted ms-1">
            {itemDiscountType === "percent" ? "%" : "GHS"}
          </small> */}
        </div>
      </div>
      <div className="col-1 g-0 text-end">
        <div className="fw-bold">{cedisLocale.format(finalAmount)}</div>
        {itemDiscount > 0 && (
          <small className="text-success">
            -{cedisLocale.format(discountAmount)} off
          </small>
        )}
      </div>
      <div className="col-1 text-center">
        <Tooltip label="Remove item">
          <ActionIcon
            color="red"
            variant="subtle"
            onClick={() => onDelete(item.recordId)}
            size="sm"
            disabled={disabled}>
            <IconTrash size={16} />
          </ActionIcon>
        </Tooltip>
      </div>
    </div>
  );
}
